function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.29 3.675l-1.165 11.072a1.288 1.288 0 01-1.28 1.152h-6.69c-.66 0-1.211-.497-1.28-1.152L2.71 3.675m-1.609 0h14.798m-10.294 0v-1.93c0-.356.288-.644.643-.644h4.504c.355 0 .643.288.643.643v1.93M8.5 6.57v6.755m2.895-6.755l-.321 6.755M5.605 6.57l.321 6.755",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17
  }, props), _ref);
}

export default SvgDelete;